import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./styles/App.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Map from "./pages/Map";
import Hall from "./pages/Hall";
import CreateCompany from "./pages/CreateCompany";
import VerificarEmail from "./pages/VerificarEmail";
import NotFound from "./pages/NotFound"; // Import the new component
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verificar-email" element={<VerificarEmail />} />
            <Route path="/" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/map" element={<Map />} />
              <Route path="/hall" element={<Hall />} />
              <Route path="/create-company" element={<CreateCompany />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;